import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "transparent", "data-test-id", "type", "textAlign"];
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Section } from 'foundations-components/transitional/components/Section';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NonTransparentDashLabel = ({
  children,
  textAlign,
  type
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(Flex, {
    flexGrow: 1,
    borderWidth: "100",
    borderStyle: "solid",
    borderColor: "border-core-subtle",
    "data-test-id": "dash-left",
    marginBlockEnd: "300"
  }), /*#__PURE__*/_jsx(View, {
    paddingInlineStart: "300",
    paddingInlineEnd: "300",
    paddingBlock: "50",
    marginBlockEnd: "25",
    borderColor: "border-core-subtle",
    borderWidth: "100",
    borderStyle: "solid",
    borderRadius: "400",
    backgroundColor: "fill-secondary-default",
    children: /*#__PURE__*/_jsx(Text, {
      use: type,
      textAlign: textAlign,
      typography: "detail-200",
      children: children
    })
  }), /*#__PURE__*/_jsx(Flex, {
    flexGrow: 1,
    borderWidth: "100",
    borderStyle: "solid",
    borderColor: "border-core-subtle",
    "data-test-id": "dash-right",
    marginBlockEnd: "300"
  })]
});
NonTransparentDashLabel.displayName = 'NonTransparentDashLabel';
const TransparentDashLabel = ({
  children,
  textAlign,
  type
}) => /*#__PURE__*/_jsx(Section, {
  paddingInlineStart: "400",
  paddingInlineEnd: "400",
  marginBlockEnd: "100",
  children: /*#__PURE__*/_jsx(Text, {
    use: type,
    textAlign: textAlign,
    typography: "detail-200",
    children: children
  })
});
TransparentDashLabel.displayName = 'TransparentDashLabel';
const LegacyDashedLabel = _ref => {
  let {
      children,
      transparent,
      ['data-test-id']: data,
      type = 'help',
      textAlign = 'center'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Flex, Object.assign({
    margin: "200",
    alignItems: "end",
    justifyContent: "center",
    "data-test-id": data || 'dashed-label'
  }, rest, {
    children: [!transparent && /*#__PURE__*/_jsx(NonTransparentDashLabel, {
      type: type,
      textAlign: textAlign,
      children: children
    }), transparent && /*#__PURE__*/_jsx(TransparentDashLabel, {
      type: type,
      textAlign: textAlign,
      children: children
    })]
  }));
};
LegacyDashedLabel.displayName = 'LegacyDashedLabel';
export default LegacyDashedLabel;